import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { NgForm } from '@angular/forms'
import { Router } from '@angular/router'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { AlertService } from '../../../common/alert/shared/alert.service'
import { OperadoraDeMaquinaService } from '../../../core/services/operadora-de-maquina.service'
import { EmpresaQueVendeComCartoes } from '../../../pkw-data/collect/empresa-que-vende-com-cartoes.model'
import { OperadoraDeMaquina } from '../../../pkw-data/collect/operadora-de-maquina.model'
import { Binario } from '../../../pkw-data/core/binario.model'
import { LocalDateConverter } from '../../../pkw-data/core/converters/local-date.converter'
import { Empresa } from '../../../pkw-data/core/empresa.model'
import { FileDownloader } from '../../shared/file-downloader'
import { DadosRelatorioService } from '../dados-relatorio.service'
import {
    OpcoesRelatorio,
    TiposDeBinarioRelatorio,
    TiposDeMovimentoRelatorio,
    TiposDeRelatorio
} from '../opcoes-relatorio.interface'
import { RelatorioService } from '../relatorio.service'
import { TIPOS_DE_MOVIMENTO } from '../../shared/tipos-de-movimento.const'

@Component({
    selector: 'col-gerar-relatorio-modal',
    templateUrl: './gerar-relatorio-modal.component.html',
    styleUrls: ['./gerar-relatorio-modal.component.scss']
})
export class GerarRelatorioModalComponent implements OnInit {
    @Input() empresasQVCC: EmpresaQueVendeComCartoes[]
    @Input() operadora: OperadoraDeMaquina
    @Input() empresas: Empresa[]
    @Input() empresa: Empresa
    @Input() inicio: Date
    @Input() fim: Date
    @Input() movimento: string

    @ViewChild(NgForm) form: NgForm

    operadoras: OperadoraDeMaquina[]
    acoes = ACOES
    tiposDeRelatorio = TIPOS_DE_RELATORIO
    tiposDeMovimentoOpts = TIPOS_DE_MOVIMENTO
    errorMsgs = ERROR_MESSAGES
    gerandoRelatorio = false

    constructor(
        private router: Router,
        private bsModalRef: BsModalRef,
        private operadoraService: OperadoraDeMaquinaService,
        private relatorioService: RelatorioService,
        private dadosRelatorioService: DadosRelatorioService,
        private alertService: AlertService
    ) {}

    ngOnInit() {
        this.operadoraService
            .obterTodas()
            .subscribe(operadoras => (this.operadoras = operadoras.filter(e=>e.ativo)))

        setTimeout(() => {
            this.initFormValues()
        })
    }

    fechar() {
        this.bsModalRef.hide()
    }

    gerar() {
        if (this.form.valid) {
            this.gerandoRelatorio = true
            const opcoes = this.getOpcoesFromFormValues()

            if (this.isRelatorioBinario(opcoes)) {
                this.gerarRelatorioBinario(opcoes)
            } else {
                this.gerarRelatorioVisualizacao(opcoes)
            }
        }
    }

    private gerarRelatorioBinario(opcoes: OpcoesRelatorio) {
        this.relatorioService.gerarBinario(opcoes).subscribe(binario => {
            if (binario.vazio) {
                this.exibirAvisosDoBinario(binario)
            } else {
                this.baixarRelatorioBinario(binario)
            }

            this.fechar()
        })
    }

    private gerarRelatorioVisualizacao(opcoes: OpcoesRelatorio) {
        this.relatorioService.gerarDados(opcoes).subscribe(dados => {
            if (
                dados.possuiVendas() ||
                dados.possuiRecebimentos() ||
                dados.possuiAntecipacoes()
            ) {
                this.dadosRelatorioService.armazenar(dados)
                this.navegarParaVisualizacao(opcoes)
            } else {
                this.alertService.info(
                    'Não existem lançamentos no período selecionado.',
                    'Aviso'
                )
            }

            this.fechar()
        })
    }

    private exibirAvisosDoBinario(binario: Binario) {
        binario.avisos.forEach(aviso => this.alertService.info(aviso, 'Aviso'))
    }

    private isRelatorioBinario(opcoes: OpcoesRelatorio) {
        return opcoes.tipoDeBinario !== undefined
    }

    private baixarRelatorioBinario(binario: Binario) {
        FileDownloader.download(binario.url)
    }

    private navegarParaVisualizacao(opcoes: OpcoesRelatorio) {
        this.router.navigate(['extratos', 'relatorio'], {
            queryParams: {
                empresa: opcoes.empresa && opcoes.empresa.empresa.idExterno,
                operadora: opcoes.operadora && opcoes.operadora.codename,
                inicio: LocalDateConverter.toJSON(opcoes.inicio),
                fim: LocalDateConverter.toJSON(opcoes.fim),
                movimento: opcoes.tipoDeMovimento,
                tipo: opcoes.tipoDeRelatorio
            }
        })
    }

    private initFormValues() {
        this.form.controls.empresa.setValue(this.empresa)
        this.form.controls.operadora.setValue(this.operadora)
        this.form.controls.inicio.setValue(this.inicio)
        this.form.controls.fim.setValue(this.fim)
        this.form.controls.tipoDeMovimento.setValue(
            this.movimento &&
                this.tiposDeMovimentoOpts.find(
                    optTipoMovimento =>
                        optTipoMovimento.tipo.toLowerCase() ===
                        this.movimento.toLowerCase()
                )
        )
        this.form.controls.tipoDeRelatorio.setValue(this.tiposDeRelatorio[0])
        this.form.controls.acao.setValue(this.acoes[0])
    }

    private getOpcoesFromFormValues(): OpcoesRelatorio {
        const empresa = this.form.value.empresa
        const tipoDeMovimento = this.form.value.tipoDeMovimento

        return {
            empresa:
                empresa &&
                this.empresasQVCC.find(eQVCC => eQVCC.empresa.id === empresa.id),
            operadora: this.form.value.operadora,
            inicio: this.form.value.inicio,
            fim: this.form.value.fim,
            tipoDeMovimento: tipoDeMovimento && tipoDeMovimento.tipo,
            tipoDeRelatorio: this.form.value.tipoDeRelatorio.tipo,
            tipoDeBinario: this.form.value.acao.tipo
        }
    }
}

const ACOES = [
    { tipo: undefined, descricao: 'Visualizar' },
    { tipo: TiposDeBinarioRelatorio.Xls, descricao: 'Relatório em *.XLS' },
    { tipo: TiposDeBinarioRelatorio.Xlsx, descricao: 'Relatório em *.XLSX' }
]

const TIPOS_DE_RELATORIO = [
    { tipo: TiposDeRelatorio.Resumido, descricao: 'Resumo da movimentação' },
    { tipo: TiposDeRelatorio.Detalhado, descricao: 'Movimentação detalhada' }
]

const ERROR_MESSAGES = { required: 'Campo obrigatório' }



// WEBPACK FOOTER //
// ./src/app/extratos/relatorio/gerar-relatorio-modal/gerar-relatorio-modal.component.ts